// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"W4-z","displaySixCardTiles":"X4-z"};